import { Injectable } from '@angular/core';
import { DepartmentStore } from './department.store';
import { Department } from './models/department.model';
import { tap, mapTo } from 'rxjs/operators';

import { ApiService } from '../../shared/services/core/api.service';
import { DepartmentQuery } from './department.query';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DepartmentService {
  /** ms to cache departments */
  ttl: number = 60000;

  constructor(
    private departmentStore: DepartmentStore,
    private departmentQuery: DepartmentQuery,
    private api: ApiService  ) {}

  /** Checks if the department is already cached using the parentCompany in the store */
  private isCached(companyId: number): boolean {
    return (
      this.departmentQuery.getValue().parentCompany
        .filter(d => d.parentCompanyId === companyId && this.cachedTimeout(d.dateCached))
        .length > 0
    );
  }

  /** Checks if the date cached is less than the ttl */
  private cachedTimeout(dateCached: Date): boolean {
    let timeDiff = new Date().getTime() - dateCached.getTime();
    return timeDiff < this.ttl;
  }

  /** Fetches all the departments and puts them into the store */
  fetchDepartments(companyId: number) {
    if (this.isCached(companyId)) {
      return of(null);
    }

    let source: Observable<Department[]> = this.api.get<Department>(
      'companies/' + companyId + '/departments'
    );

    return source.pipe(
      tap(departments => this.departmentStore.upsertMany(departments)),
      tap(() => this.departmentStore.addCachedCompany(companyId)),
      mapTo(null)
    );
  }

  processAffiliate(companyId: number, departmentId: number): Observable<string> {
    return this.api.post<string>(`companies/${companyId}/departments/${departmentId}/affiliate`, '', undefined);
  }
}
